import React, { type ReactNode } from 'react'
import { Switch } from '@headlessui/react'
import { twMerge } from 'tailwind-merge'

interface CheckBoxSwitcherProps {
  selected: boolean
  onChange: (value: boolean) => void
  label?: React.ReactNode | string
  labelClassName?: string
  disabled?: boolean
}

function Label({
  label,
  labelClassName,
}: {
  label?: React.ReactNode | string
  labelClassName?: string
}): ReactNode | null {
  if (!label) {
    return null
  }

  return <div className={labelClassName}>{label}</div>
}

const CheckBoxSwitcher = ({
  selected,
  onChange,
  label,
  labelClassName,
  disabled,
}: CheckBoxSwitcherProps): ReactNode => {
  return (
    <div className="relative flex flex-col gap-2 md:flex-row">
      <Switch
        checked={selected}
        onChange={onChange}
        className={twMerge(
          `relative inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent main-transition-colors focus:outline-hidden focus-visible:ring-2 focus-visible:ring-background-secondary/75`,
          selected && !disabled ? 'bg-brand-primary' : `bg-background-tertiary`,
        )}
      >
        <span
          aria-hidden="true"
          className={twMerge(
            selected ? 'translate-x-5' : `translate-x-0`,
            `pointer-events-none inline-block size-4 rounded-full bg-background-secondary shadow-lg ring-0 main-transition-colors transition-transform duration-200 ease-linear`,
          )}
        />
      </Switch>
      <Label label={label} labelClassName={labelClassName} />
    </div>
  )
}

export default CheckBoxSwitcher
